import React from 'react';
import Moment from 'react-moment';

export function FormatDate({ date, className }) {
  return (
    <div className={className}>
      <Moment className="d-inline-block" format="YYYY-MM-DD hh:mm A">
        {date}
      </Moment>
    </div>
  );
}
